import { Dialog, Popover, Transition } from "@headlessui/react";
import { Icon } from "@iconify/react";
import {
  addOtherUserPlaylist,
  deleteUserPlaylist,
  getPlaylistDetails,
  getUserPlaylistDetails,
  setUserSettings,
} from "../../api/api";
import {
  BlueLinearGradient,
  BlueTextLinearGradient,
  isSubscriptionExpired,
  showInstructionDialog,
  WhiteLinearGradient,
} from "../../utils/Utils";
import ic_clock from "../../assets/icons/ic_clock.svg";
import { UserPlaylistExerciseCard } from "../playlistDialog/Exercise";
import ic_delete from "../../assets/icons/ic_delete.svg";
import ic_kebab from "../../assets/icons/ic_kebab.svg";
import ic_share_black from "../../assets/icons/ic_share_black.svg";
import ic_calories from "../../assets/icons/ic_calories.svg";
import more_module from "../../assets/images/more_module.png";
import React, { Fragment, useEffect, useState } from "react";
import { WhatsappShareButton } from "react-share";
import { toast } from "react-toastify";
import SidePanel from "../basic/SidePanel";
import Button from "../basic/Button";
import { useAuthContext } from "../../context/AuthContext";
import PlanExpiredDialog from "../subscription/PlanExpiredDialog";
import Cookies from "js-cookie";
import { useAppContext } from "../../context/AppContext";
import ShareDialog from "./ShareDialog";
import CustomDialog from "../basic/Dialog";
import InstructionDialog from "./InstructionDialog";
import IconButton from "../basic/IconButton";
import PlaylistIcon from "../../assets/icons/PlaylistIcon";

export function SkeletonPlaylist({ numberOfPlaylist }) {
  const Skeleton = () => {
    return (
      <div className=" shadow-2xl rounded-xl  max-w-sm w-full mx-auto">
        <div className="animate-pulse flex flex-col">
          <div className="bg-slate-200 space-y-5 rounded-t-xl h-[200px] p-5 flex flex-col justify-center items-center">
            <div className="h-3 rounded-xl bg-slate-400  w-1/3"></div>
            <div className="h-6 rounded-xl bg-slate-400  w-2/3"></div>
          </div>
          <div className="bg-slate-400 rounded-b-xl h-9"></div>
        </div>
      </div>
    );
  };
  return (
    <div className="my-14">
      {[...Array(numberOfPlaylist || 3).keys()].map((item) => {
        return (
          <div className="animate-pulse flex flex-col" key={item}>
            <div className="space-y-5 flex flex-col ">
              <div className="h-6 rounded-xl bg-slate-400  w-1/5"></div>
              <div className="gap-5 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 items-center justify-center">
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function UserPlaylistSidePanel({
  playlist,
  exercises,
  show,
  close,
  onExerciseDelete,
}) {
  const auth = useAuthContext();
  const appState = useAppContext();
  const [showPlanExpired, setShowPlanExpired] = useState(false);
  return (
    <SidePanel
      open={show}
      closeSideBar={close}
      background={WhiteLinearGradient}
    >
      <PlanExpiredDialog
        show={showPlanExpired}
        close={() => {
          setShowPlanExpired(false);
        }}
      />
      <div
        style={{
          backgroundImage:
            " linear-gradient(180deg, rgba(6, 229, 229, 0.718854) 0%, #1A59DB 100%)",
        }}
        className={` bg-cover  w-full `}
      >
        <div className="p-4">
          <div className="flex flex-row mt-20 items-center">
            <div className=" flex flex-col flex-1">
              <div className="flex flex-row space-x-4">
                <p className="font-medium text-2xl text-white ">
                  {playlist.playlistName}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="m-4">
        <div className="flex gap-x-5 text-primary-black">
          <div className="flex items-center gap-x-2">
            <Icon
              icon="healthicons:exercise-running"
              className="h-5 w-auto"
              color={appState.state.darkMode ? "#fff" : "#000"}
            />
            <p className="font-medium text-sm text-black dark:text-primary-white">
              {exercises.length} EXERCISES
            </p>
          </div>
          <div className="flex-1"></div>
          {exercises.length > 0 &&
            (auth.state.user &&
            isSubscriptionExpired(auth.state.user.expiresAt) ? (
              <Button
                type="primary"
                onClick={() => {
                  setShowPlanExpired(true);
                }}
              >
                Start
              </Button>
            ) : (
              <a href={`${playlist.playlistUrl}`} className={"self-end"}>
                <Button type="primary">Start</Button>
              </a>
            ))}
        </div>
        <div className="flex flex-col p-4 space-y-4">
          {exercises.map((exercise, index) => {
            return (
              <UserPlaylistExerciseCard
                {...exercise}
                key={index}
                onExerciseDelete={onExerciseDelete}
                allowShare={false}
                canDelete
                playlistId={playlist.playlistId}
              />
            );
          })}
        </div>
      </div>
    </SidePanel>
  );
}

export function PlaylistSidePanel({ playlist, exercises, show, closeSideBar }) {
  const auth = useAuthContext();
  const [showPlanExpired, setShowPlanExpired] = useState(false);
  const [playAudio, setPlayAudio] = useState(
    auth.state.playInstructionAudio || true
  );
  const appState = useAppContext();
  const [showInstruction, setShowInstruction] = useState(false);

  useEffect(() => {
    setPlayAudio(auth.state.playInstructionAudio);
  }, [auth.state.playInstructionAudio]);
  return (
    <SidePanel
      open={show}
      closeSideBar={closeSideBar}
      background={WhiteLinearGradient}
    >
      <PlanExpiredDialog
        show={showPlanExpired}
        close={() => {
          setShowPlanExpired(false);
        }}
      />
      <InstructionDialog
        show={showInstruction}
        close={() => {
          if (!playAudio && auth.state.playInstructionAudio) {
            setPlayAudio(true);
          }
          setShowInstruction(false);
        }}
        redirectUrl={playlist.playlistUrl}
      />

      <div className="flex flex-col  w-full h-full">
        <div
          style={{
            backgroundImage: playlist.activityImage
              ? `url(${playlist.activityImage})`
              : " linear-gradient(180deg, rgba(6, 229, 229, 0.718854) 0%, #1A59DB 100%)",
          }}
          className={` bg-cover  w-full `}
        >
          {playlist.playlistAudio && (
            <div
              className={`rounded-full ${
                playAudio ? WhiteLinearGradient : BlueLinearGradient
              } absolute w-8 h-8 flex justify-center items-center right-5 top-5`}
              onClick={() => {
                Cookies.set("playAudio", !playAudio);
                setUserSettings({
                  update: JSON.stringify({
                    musicMute: !playAudio ? 1 : 0,
                  }),
                });
                auth.updatePlayInstructionAudio(!playAudio);
                // setPlayAudio(!playAudio);
              }}
            >
              <Icon
                icon="ion:volume-mute-outline"
                color={playAudio && !appState.state.darkMode ? "#000" : "#fff"}
              />
            </div>
          )}
          <div className="h-56 px-4 py-8 space-y-2 flex flex-1 flex-col bg-black bg-opacity-60 justify-center items-center ">
            <p
              className={`${
                playlist.subName
                  ? "font-medium text-lg"
                  : "font-extrabold text-xl"
              } text-center text-primary-neonGreen italic   `}
            >
              {playlist.mainName}
            </p>
            <p className="font-bold text-white text-2xl uppercase text-center">
              {playlist.subName}
            </p>
          </div>
        </div>
        <div className="p-4">
          {playlist.playlistAudio && playAudio && (
            <audio src={playlist.playlistAudio} autoPlay />
          )}
          <div className="flex gap-x-5 text-primary-black">
            <div className="flex items-center gap-x-2">
              <Icon
                icon="akar-icons:clock"
                className="h-5 w-auto"
                color={appState.state.darkMode ? "#fff" : "#000"}
              />
              <p className="font-medium text-sm uppercase text-black dark:text-primary-white">
                {playlist.duration}
              </p>
            </div>
            <div className="flex items-center gap-x-2">
              <Icon
                icon="healthicons:exercise-running"
                color={appState.state.darkMode ? "#fff" : "#000"}
                className="h-5 w-auto"
              />
              <p className="font-medium text-sm text-black dark:text-primary-white">
                {exercises.length} EXERCISES
              </p>
            </div>
            <div className="flex-1"></div>
            {auth.state.user &&
            isSubscriptionExpired(auth.state.user.expiresAt) ? (
              <Button
                type="primary"
                onClick={() => {
                  setShowPlanExpired(true);
                }}
              >
                Start
              </Button>
            ) : (
              <Button
                type="primary"
                onClick={(e) => {
                  if (showInstructionDialog()) {
                    setPlayAudio(false);
                    setShowInstruction(true);
                  }
                }}
              >
                {showInstructionDialog() ? (
                  "Start"
                ) : (
                  <a href={`${playlist.playlistUrl}`} className={"self-end"}>
                    Start
                  </a>
                )}
              </Button>
            )}
          </div>
          <p className="text-lg my-5 font-medium text-black dark:text-primary-white">
            {playlist.description}
          </p>
          <div className="flex flex-col overflow-y-auto mt-4 gap-y-2">
            {exercises.map((exercise, index) => {
              return (
                <UserPlaylistExerciseCard
                  {...exercise}
                  key={index}
                  onExerciseDelete={() => {}}
                  allowShare={false}
                />
              );
            })}
          </div>
        </div>
      </div>
    </SidePanel>
  );
}

export function Playlist({
  playlistName,
  playlistId,
  playlistCat,
  playlistShortUrl,
  playlistExerciseId,
  description,
  duration,
  time,
  badgeText,
  activityImage,
  mainName,
  subName,
  showInstructionBeforeRedirect,
  playlistAudio,
  playlistVideo,
  url,
  testURL,
}) {
  const [showDetails, setShowDetails] = useState(false);
  const [exercises, setExercises] = useState([]);

  async function updateExerciseList() {
    let response = await getPlaylistDetails(playlistId);
    const list = [];
    response?.data?.exercises?.forEach((element) => {
      console.log("element: ", element);
      list.push({
        exerciseName: element.exerciseName,
        description: element.exercisesBenefits,
        details: [
          {
            icon: ic_clock,
            text: element.exercisesDuration + " secs",
            alwaysShow: true,
          },
          {
            text: element.exercisescoinsMultipli,
            alwaysShow: false,
          },
        ],
        exerciseUri: element.exerciseURI,
        id: element.exerciseId,
        exerciseImage: element.activityImage,
        exerciseVideo: element.exerciseVideo,
        exerciseAudio: element.exerciseAudio,
      });
    });
    setExercises(list);
  }

  useEffect(() => {
    updateExerciseList();
  }, []);

  const appState = useAppContext();

  const [showShareDialog, setShowShareDialog] = useState(false);

  // Hide Side Panel Drawer
  const auth = useAuthContext();
  // const navigate = useNavigate();
  const [showPlanExpired, setShowPlanExpired] = useState(false);
  const [playAudio, setPlayAudio] = useState(
    auth.state.playInstructionAudio || true
  );
  const [showInstruction, setShowInstruction] = useState(false);

  useEffect(() => {
    setPlayAudio(auth.state.playInstructionAudio);
  }, [auth.state.playInstructionAudio]);

  return (
    <>
      {/* <PlaylistSidePanel
        playlist={{
          playlistName,
          playlistId,
          playlistCat,
          playlistShortUrl,
          playlistExerciseId,
          description,
          badgeText,
          duration: duration || time,
          activityImage,
          mainName,
          subName,
          playlistVideo,
          playlistAudio,
          playlistUrl: testURL,
        }}
        exercises={exercises}
        show={showDetails}
        closeSideBar={() => {
          setShowDetails(false);
        }}
      /> */}
      {/* <ShareDialog
        show={showShareDialog}
        close={() => {
          setShowShareDialog(false);
        }}
        // shareLink={`https://getactyv.com/exercise?routineId=${playlistId}`}
        shareLink={`https://getactyv.com/programpage?routineId=${playlistId}`}
        shareMessage={`Hey, I just finished a ${playlistName} routine on getactyv.com. You can try it too and get active!`}
      /> */}
      <ShareDialog
        show={showShareDialog}
        close={() => {
          setShowShareDialog(false);
        }}
        // shareLink={`https://getactyv.com/exercise?routineId=${playlistId}`}
        shareLink={`https://getactyv.com/programpage?routineId=${playlistId}`}
        shareMessage={`Hey, I just finished a ${playlistName} routine on getactyv.com. You can try it too and get active!`}
      />
      <PlanExpiredDialog
        show={showPlanExpired}
        close={() => {
          setShowPlanExpired(false);
        }}
      />
      <InstructionDialog
        show={showInstruction}
        close={() => {
          if (!playAudio && auth.state.playInstructionAudio) {
            setPlayAudio(true);
          }
          setShowInstruction(false);
        }}
        redirectUrl={testURL}
      />
      <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[300px] max-h-full">
        <div
          className="flex flex-1 transform rounded-2xl h-full hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500  w-full"
          // onClick={() => {
          //   setShowDetails(true);
          // }}
          onClick={() => {
            // setShowDetails(true);
            if (isSubscriptionExpired(auth.state.user.expiresAt)) {
              setShowPlanExpired(true);
            } else if (showInstructionDialog) {
              setPlayAudio(false);
              setShowInstruction(true);
            } else {
              window.location.href = `http://localhost:3000/programpage/${testURL}`;
            }
          }}
        >
          <div
            style={{
              backgroundImage: `url(${activityImage})`,
              backgroundAttachment:
                "bg-gradient-to-b from-gray-900 to-gray-600 bg-gradient-to-r",
            }}
            className={`bg-center bg-cover rounded-b-2xl rounded-t-xl w-full h-full flex flex-col`}
          >
            <div
              //  className={`bg-gradient-to-b from-gray-900 to-gray-600 bg-black bg-opacity-60 rounded-b-2xl rounded-t-xl h-full`}
              className={`bg-black bg-opacity-60 rounded-b-2xl rounded-t-xl h-full`}
            >
              <div className="flex flex-col h-full">
                <div className="flex w-full self-end items-center gap-2 p-2">
                  <div className="flex-1" />
                  <IconButton
                    iconComponent={
                      <Icon
                        icon="carbon:overflow-menu-vertical"
                        className="flex md:h-6 md:w-6 text-white "
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowShareDialog(true);
                        }}
                      />
                    }
                    // className="bg-opacity-60 justify-center h-7 w-7  z-10"
                    className="bg-[#111525] bg-opacity-50 justify-center h-7 w-7 z-10"
                  />
                </div>
                <div className="flex flex-1 items-end  w-full">
                  <div className="flex w-full pr-1.5">
                    <div className="px-1  flex flex-1 flex-col  rounded-xl ">
                      <p
                        className={`${
                          subName
                            ? "font-medium text-md"
                            : "font-extrabold text-lg"
                        }  text-primary-neonGreen italic   `}
                      >
                        {mainName}
                      </p>
                      <p className="font-bold font-poppins text-white text-lg md:text-xl uppercase ">
                        {subName}
                      </p>
                    </div>
                    {/* <Icon
                      icon="mdi:cards-heart"
                      className="flex md:h-7 md:w-7 text-white opacity-70 "
                      onClick={(e) => {
                        e.stopPropagation();
                        <Icon
                        icon="mdi:cards-heart"
                        className="flex md:h-7 md:w-7 text-red-900 "
                        />
                      }}
                    /> */}
                  </div>
                </div>

                <div
                  className={`px-2 md:px-2 py-3 flex flex-row bg-black-300 items-center rounded-b-xl`}
                >
                  <div className="flex items-center gap-x-1">
                    <PlaylistIcon
                      color={appState.state.darkMode ? "#fff" : "#000"}
                    />
                    <p className="hidden md:block font-medium text-xs font-open-sans text-black dark:text-primary-white">
                      {exercises.length}{" "}
                      {exercises.length > 1 ? "Exercises" : "Exercise"}
                    </p>
                    <p className="block md:hidden font-medium text-xs font-open-sans text-black dark:text-primary-white">
                      {exercises.length}
                    </p>
                  </div>
                  <div className="flex flex-1"></div>
                  {(duration || time) && (
                    <div className="flex items-center gap-x-1">
                      <Icon
                        icon="akar-icons:clock"
                        className="h-3.5 w-auto"
                        color={appState.state.darkMode ? "#fff" : "#000"}
                      />
                      <p className="font-medium text-xs font-open-sans text-black dark:text-primary-white">
                        {duration
                          ? duration.split(" ")[0]
                          : time
                          ? time.split(" ")[0]
                          : ""}{" "}
                        mins
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export function SharedUserPlaylistDialog({
  playlist,
  exercises,
  onPlaylistAdded,
  show,
  close,
}) {
  const appState = useAppContext();
  return (
    <CustomDialog show={show} close={close}>
      <Dialog.Panel className={`${WhiteLinearGradient} rounded-xl`}>
        <div
          style={{
            backgroundImage:
              " linear-gradient(180deg, rgba(6, 229, 229, 0.718854) 0%, #1A59DB 100%)",
          }}
          className={` bg-cover  w-full rounded-t-xl`}
        >
          <div className="p-4">
            <div className="flex flex-col space-y-16 items-end">
              <div className="flex flex-row items-center space-x-5">
                <p className="text-primary-white">{`To try ${playlist.user_name}'s playlist, click on add to my playlist`}</p>
                <button
                  type="button"
                  className={`rounded-full p-1 ${WhiteLinearGradient} `}
                  onClick={close}
                >
                  <Icon
                    icon="carbon:close"
                    color={appState.state.darkMode ? "#fff" : "#000"}
                    className="h-6 w-6"
                  />
                </button>
              </div>
              <p className="font-medium text-2xl text-white w-full">
                {playlist.playlistName}
              </p>
              <Button
                type="primary"
                onClick={async () => {
                  const response = await addOtherUserPlaylist(
                    playlist.playlistId
                  );
                  if (response.success) {
                    toast("Playlist added successfully");
                    close();
                    onPlaylistAdded();
                  }
                }}
                className="max-w-max self-end flex"
              >
                Add to My Playlist
              </Button>
            </div>
          </div>
        </div>
        <div className="m-4">
          <div className="flex gap-x-5 text-primary-black">
            <div className="flex items-center gap-x-2">
              <Icon
                icon="healthicons:exercise-running"
                className="h-5 w-auto"
                color={appState.state.darkMode ? "#fff" : "#000"}
              />
              <p className="font-medium text-sm text-black dark:text-primary-white">
                {exercises.length}{" "}
                {exercises.length > 1 ? "EXERCISES" : "EXERCISE"}
              </p>
            </div>
            <div className="flex-1"></div>
          </div>
          <div className="flex flex-col p-4 space-y-4">
            {exercises.map((exercise, index) => {
              return (
                <UserPlaylistExerciseCard
                  {...exercise}
                  key={index}
                  // onExerciseDelete={onExerciseDelete}
                  allowShare={false}
                  playlistId={playlist.playlistId}
                />
              );
            })}
          </div>
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

export function UserPlaylist({
  playlistName,
  playlistId,
  playlistShortUrl,
  showInstructionBeforeRedirect,
  url,
  index,
  onPlaylistDelete,
}) {
  const [showDetails, setShowDetails] = useState(false);
  const [exercises, setExercises] = useState([]);

  const deletePlaylist = async () => {
    const response = await deleteUserPlaylist(playlistId);
    toast("Playlist Deleted", { type: "success" });
    onPlaylistDelete();
  };

  async function updateExerciseList() {
    let response = await getUserPlaylistDetails(playlistId);
    const list = [];
    response?.data?.exercises?.forEach((element) => {
      list.push({
        exerciseName: element.exerciseName,
        description: element.exercisesBenefits,
        details: [
          {
            icon: ic_clock,
            text: element.exercisesDuration + " secs",
            alwaysShow: true,
          },
          {
            text: element.exercisescoinsMultipli,
            alwaysShow: false,
          },
        ],
        exerciseUrl: element.exerciseURI,
        exerciseId: element.exercises_id,
        exerciseImage: element.activityImage,
        exerciseVideo: element.exerciseVideo,
        exerciseAudio: element.exerciseAudio,
      });
    });
    setExercises(list);
  }

  useEffect(() => {
    updateExerciseList();
  }, []);
  const appState = useAppContext();
  const gradients = [
    "from-[#06E5E5] to-[#1A59DB]",
    "from-[#3AC772] to-[#06E5E5]",
    "from-[#F6D738] to-[#EB5E00]",
    "from-[#F54D46] to-[#FF0000]",
    "from-[#F546EE] to-[#FF0000]",
  ];
  const [showShareDialog, setShowShareDialog] = useState(false);
  return (
    <div className="group flex flex-1 flex-col rounded-xl shadow-xl justify-center items-center -z-0 w-full min-h-[200px] max-h-full">
      <ShareDialog
        show={showShareDialog}
        close={() => {
          setShowShareDialog(false);
        }}
        // shareLink={`https://getactyv.com/exercise?userPlaylistId=${playlistId}`}
        shareLink={`https://getactyv.com/programpage?userPlaylistId=${playlistId}`}
        shareMessage={`Hey, I created a playlist named ${playlistName} on getactyv.com. You can try it too and get active!`}
      />
      <UserPlaylistSidePanel
        playlist={{
          playlistName,
          playlistId,
          playlistShortUrl,
          playlistUrl: url,
        }}
        onExerciseDelete={() => {
          updateExerciseList();
        }}
        exercises={exercises}
        show={showDetails}
        close={() => {
          setShowDetails(false);
        }}
      />
      <div
        className={`flex flex-1 transform h-full rounded-t-xl rounded-b-2xl shadow-xl bg-gradient-to-b ${
          gradients[Math.floor(index % gradients.length)]
        } hover:cursor-pointer transition-all hover:shadow-3xl hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500   w-full`}
        onClick={() => {
          setShowDetails(true);
        }}
      >
        <div
          className={` bg-center bg-cover rounded-xl w-full h-full flex flex-col flex-1`}
        >
          <div
            className="flex justify-end -pt-40 p-2 hover:cursor-pointer"
            onClick={(e) => {
              deletePlaylist();
              // close();
              e.stopPropagation();
            }}
          >
            <img src={ic_delete} className="w-5 h-5" />
          </div>
          <Popover className={"relative focus:outline-none self-end p-2"}>
            <Popover.Button className={""}>
              {/* <img src={ic_kebab} className="h-5 w-auto" /> */}
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-0"
              enterTo="opacity-100 translate-y-1"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-1"
              leaveTo="opacity-0 translate-y-0"
            >
              <Popover.Panel
                className={
                  "absolute z-20 w-32 mt-3 -ml-28 focus:outline-none p-3  flex flex-col bg-white rounded-xl"
                }
              >
                {({ close }) => (
                  <div className="space-y-2">
                    <div
                      className="flex flex-row items-center hover:cursor-pointer"
                      onClick={(e) => {
                        deletePlaylist();
                        close();
                        e.stopPropagation();
                      }}
                    >
                      <img src={ic_delete} className="w-5 h-5" />
                      <p className="font-bold pl-2 text-gray-800 flex-1">
                        Delete
                      </p>
                    </div>
                    <div className="h-[1px] bg-customGray-300"></div>
                    <div
                      className="flex flex-row items-center hover:cursor-pointer"
                      onClick={(e) => {
                        setShowShareDialog(true);
                        close();
                        e.stopPropagation();
                      }}
                    >
                      {" "}
                      <img src={ic_share_black} className="w-5 h-5" />
                      <p className="font-bold pl-2 text-gray-800 flex-1">
                        Share
                      </p>
                    </div>
                  </div>
                )}
              </Popover.Panel>
            </Transition>
          </Popover>
          <div className="flex flex-col h-full flex-1">
            {/* <div
              className="flex -pt-40 pr-1 hover:cursor-pointer"
              onClick={(e) => {
                deletePlaylist();
                // close();
                e.stopPropagation();
              }}
            >
              <img src={ic_delete} className="w-5 h-5" />
            </div> */}
            <p className="font-medium mt-16 text-xl md:text-2xl px-4 py-2 text-white flex flex-1 items-end">
              {playlistName}
            </p>
            <div
              className={`md:px-4 py-1 flex flex-row ${WhiteLinearGradient} items-center rounded-b-xl`}
            >
              <Icon
                icon="healthicons:exercise-running"
                color={appState.state.darkMode ? "#fff" : "#000"}
                className="h-5/6 w-auto  "
              />
              <p className="ml-2 text-sm md:text-base font-bold text-black dark:text-primary-white flex flex-1">
                {exercises.length}{" "}
                {exercises.length > 1 ? "EXERCISES" : "EXERCISE"}
              </p>
              {/* <img src={ic_playlist} className="h-5 w-auto  " /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const MemoizedPlaylists = React.memo(Playlists);

export function Playlists({
  playlist,
  playlistName,
  initialOpen,
  userPlaylist = false,
  onPlaylistDelete,
}) {
  return (
    <div className="my-14">
      <p className={`font-medium text-2xl ${BlueTextLinearGradient}`}>
        {playlistName == "Sports Module"
          ? "Sports Fitness"
          : playlistName == "Fitness Module"
          ? "General Fitness"
          : playlistName}
      </p>
      {!userPlaylist && (
        <div className="mt-10 gap-5 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {playlist.map((list, index) => {
            return <Playlist {...list} key={index} />;
          })}
          {playlist.length < 5 ? (
            <div
              className="flex flex-row col-span-1 bg-cover rounded-xl bg-center h-52 lg:h-full justify-center items-center "
              style={{ backgroundImage: `url(${more_module})` }}
            >
              <p className="flex text-white font-bold md:text-xl text-center">
                More coming soon
              </p>
            </div>
          ) : null}
        </div>
      )}
      {userPlaylist && (
        <div className="mt-10 gap-5 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {playlist.map((list, index) => {
            return (
              <UserPlaylist
                {...list}
                key={index}
                onPlaylistDelete={onPlaylistDelete}
                index={index}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
